import React, { createContext, useContext, useState, useCallback } from 'react';
import { X } from 'lucide-react';

const AlertContext = createContext(null);

export function AlertProvider({ children }) {
  const [alerts, setAlerts] = useState([]);

  const showAlert = useCallback((title, message, type = 'info') => {
    const id = Date.now();
    setAlerts(a => [...a, { id, title, message, type }]);
    setTimeout(() => setAlerts(a => a.filter(x => x.id !== id)), 4000);
  }, []);

  const removeAlert = (id) => setAlerts(a => a.filter(x => x.id !== id));

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <div style={{ position: 'fixed', bottom: '1.5rem', right: '1.5rem', zIndex: 99999, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        {alerts.map(alert => (
          <div key={alert.id} style={{
            background: '#1a1a1a', border: '1px solid rgba(255,255,255,0.15)',
            borderRadius: '1rem', padding: '1.25rem 1.5rem', minWidth: '300px', maxWidth: '400px',
            boxShadow: '0 20px 40px rgba(0,0,0,0.5)', animation: 'slideInRight 0.3s ease',
          }}>
            <style>{`@keyframes slideInRight { from { opacity:0; transform:translateX(100%); } to { opacity:1; transform:translateX(0); } }`}</style>
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '1rem' }}>
              <div>
                <p style={{ color: 'white', fontWeight: 700, fontSize: '0.9rem', marginBottom: '0.25rem' }}>{alert.title}</p>
                {alert.message && <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.8rem' }}>{alert.message}</p>}
              </div>
              <button onClick={() => removeAlert(alert.id)} style={{ color: 'rgba(255,255,255,0.3)', flexShrink: 0, marginTop: '2px' }}>
                <X size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </AlertContext.Provider>
  );
}

export const useAlert = () => useContext(AlertContext);
